import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getCampuses } from '../api/campuses.api';
import { ICampusItem, IGetCampuses } from '../models/campuses.model';

interface ICampusDataState {
  campusData: ICampusItem[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: ICampusDataState = {
  campusData: [],
  isLoading: false,
};

const campusDataSlicer = createSlice({
  name: 'campusData',
  initialState,
  reducers: {
    getCampusDataStart: (state: ICampusDataState) => {
      state.campusData = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getCampusDataSuccess: (
      state: ICampusDataState,
      action: PayloadAction<IGetCampuses>,
    ) => {
      state.campusData = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getCampusDataFailure: (
      state: ICampusDataState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.campusData = [];
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getCampusDataStart,
  getCampusDataSuccess,
  getCampusDataFailure,
} = campusDataSlicer.actions;

export default campusDataSlicer.reducer;

export const doGetCampusData = (): any => async (dispatch: any) => {
  try {
    dispatch(getCampusDataStart());
    const response = await getCampuses();
    dispatch(getCampusDataSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getCampusDataFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
